<template>
    <Progressbar v-if="loading" />
    <NetworkError v-else-if="!appointments.length && errors" @tryAgain="getAppointments" />
    <div class="w-full h-full bg-gray-200 dark:bg-base-100 rounded-tr-3xl xl:px-9 pt-6 lg:pt-10 pb-14 " v-else>
        <div class="container">
            <div class="flex flex-col md:flex-row justify-between items-center md:items-center mb-6 lg:mb-8">
                <h3 class="flex items-center md:text-26 text-2xl dark:text-white text-biscay-700 font-semibold">
                    <i class="md:flex hidden w-2 h-2 dark:bg-white rounded-full bg-blue-700 ml-2"></i>
                    {{ __('All activities') }}
                </h3>
                <div class="flex mt-6 md:mt-0 flex-col lg:flex-row w-full md:w-auto justify-end" v-if="!modal">
                    <div class="flex mt-4 lg:mt-0 justify-end">
                        <input
                            class="input w-full h-10 xl:pl-36 placeholder-gray-320 md:w-64 xl:w-80 ml-2 bg-gray-350 bg-opacity-10 rounded-lg  transition duration-200 text-sm text-gray-350 px-3 font-medium dark:!bg-base-300 dark:!text-white  focus:bg-blue-700 focus:bg-opacity-10 border border-blue-700  focus:border-opacity-100"
                            type="text" :placeholder="__('Search...')" v-model="searchValue">
                        <button @click="search"
                            class=" bg-blue-600 disabled:opacity-70 disabled:!bg-blue-600 flex items-center h-10 md:px-5 px-3 rounded-md text-white font-semibold text-sm transition duration-200 hover:bg-blue-800 ">
                            {{ __('Search') }}
                        </button>
                    </div>
                    <div class="flex order-first justify-between lg:order-last">
                        <div class="dropdown dropdown-hover lg:mr-4">
                        <div tabindex="0" class="btn btn-info btn-outline btn-base">
                         <span>{{ state}}</span>
                                <i
                                    class="flex md:ml-1 ml-2 md:mr-2 mr-2 h-6 border-l dark:border-blue-450 border-blue-700 border-opacity-30 transition duration-200"></i>
                                <svg width="10" height="7" viewBox="0 0 10 7" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        class="stroke-current dark:text-blue-450 text-blue-700 transition duration-200"
                                        d="M8.58333 1.60425L4.79167 5.39591L1 1.60425" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round"></path>
                                </svg>
                        </div>
                        <ul tabindex="0" class="p-2 shadow menu dropdown-content z-[1] bg-base-100 rounded-box lg:w-40">
                            <li class="text-xs lg:text-base" v-for="item in statusTypes"><a :class="{'btn-active': ($route.query.status || 'all') == item}" @click="controleState($event, item)" :data-filter-id="item">{{ __(item.replace('_', ' ').capitalize())  }}</a></li>
                        </ul>
                    </div>
                    <div class="flex justify-end order-first lg:order-last lg:mr-4" v-if="can('appointment.create')">
                        <router-link :to="{name: 'user.appointment.create'}"
                            class="btn btn-outline btn-info btn-base">
                            <span class="mt-0.5">{{ __('Create activity') }}</span>
                        </router-link>
                    </div>
                    </div>
                </div>
            </div>
            <div class="rounded-2xl dark:bg-base-300 bg-white">
                <TableAppointment :appointments="appointments" @setItem="setItem" :modal="modal" @show="pushTo" @edit="pushTo" />
            </div>
            <Pagination :meta="meta" @setPage="setPage" class="!mt-6" />
        </div>
    </div>
     <ModalDelete id="appointment-delete-modal" :title="__('Delete appointment')" :content="__('Are you sure to delete this appointment?')"  @remove="removeAppointment" />
</template>
<script setup>
import { ref, onMounted, computed ,onUpdated} from 'vue';

const { getAppointments, loading, errors, meta, router,remove, route, appointments,removeAppointment } = useDashboard();
const searchValue = ref(route.query.search || '');
// const statusTypes = computed(() => baseName.value == 'task' ? ['all','not_started','pending_input', 'in_progress', 'deferred','complete'] : ['all','planning', 'not_held', 'held']);
const statusTypes = computed(() => ['all','not_started','pending_input', 'in_progress', 'deferred','complete']);
const state = ref('');
const props = defineProps(['modal','model_type','model_id']);
const emit = defineEmits(['show','edit']);
const pushTo = (type, id) => {
  emit(type, type, id);
};
// let routeName = route.name
const setQuery = (key, value) => {
    getAppointments(window.setQuery(router, route, key, value));
}

const controleState = (e, filter) => {
    state.value = e.target.textContent.trim()
    setQuery('status', filter);
}
const setPage = (p) => {
    setQuery('page', p.toString());
};
const setItem = (item) => Object.assign(remove, item);
const search = () => {
    setQuery('search', searchValue.value)
}
onMounted(() => {
    const query = route.query;
    if(props.model_type) query.model_type = props.model_type;
    if(props.model_id) query.model_id = props.model_id;
    getAppointments(query);
});
onUpdated(() => state.value = document.querySelector(`[data-filter-id=${route.query.status || 'all'}]`)?.textContent?.trim());
</script>